/** Validation for invite forms that require invitee first and last name. */
export function getInviteNameValidationError(
  firstName: string,
  lastName: string,
): string | null {
  if (!firstName.trim()) return 'First name is required';
  if (!lastName.trim()) return 'Last name is required';
  return null;
}

export function trimInvitePersonNames(firstName: string, lastName: string) {
  return {
    firstName: firstName.trim(),
    lastName: lastName.trim(),
  };
}
